if (!customElements.get("product-set-selector")) {
  customElements.define(
    "product-set-selector",
    class ProductSetSelector extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest("product-info");
        this.form = document.getElementById(this.dataset.formId);
        this.variantInput = this.form?.querySelector('[name="id"]');
        this.priceContainer = this.productInfo?.querySelector(
          `#Price-${this.dataset.sectionId}`
        );
        this.purchaseOptions = this.productInfo?.querySelector(
          "purchase-options"
        );
        this.dynamicCheckout = this.form?.querySelector(
          ".f-product-form__button-dynamic"
        );
        this.pickupAvailability = this.productInfo?.querySelector(
          "pickup-availability"
        );
        this.cards = Array.from(this.querySelectorAll("[data-set-card]"));
        this.priceSnapshot = this.priceContainer?.innerHTML || "";
        this.dynamicCheckoutWasHidden = this.dynamicCheckout?.hidden || false;
        this.pickupWasHidden = this.pickupAvailability?.hidden || false;
        this.originalVariantId = this.variantInput?.value || "";
        this.stickyBar = document.querySelector(
          `sticky-atc-bar[data-product-id="${this.dataset.productId}"]`
        );
        this.stickySelect = this.stickyBar?.querySelector('[name="id"]');
        this.stickyPrice = this.stickyBar?.querySelector(".f-price");
        this.stickyOptionsSnapshot = this.stickySelect?.innerHTML || "";
        this.stickyPriceSnapshot = this.stickyPrice?.innerHTML || "";
        this.stickyPriceClassSnapshot = this.stickyPrice?.className || "";

        if (!this.form || !this.variantInput) return;

        this.addEventListener("change", this.onChange.bind(this));
        this.syncSelection();
      }

      onChange(event) {
        if (!event.target.matches("[data-set-option]")) return;
        this.syncSelection();
      }

      syncSelection() {
        const input = this.querySelector("[data-set-option]:checked");
        const card = input?.closest("[data-set-card]");
        if (!card) return;

        const isSet = card.dataset.isSet === "true";
        const available = card.dataset.available === "true";

        this.cards.forEach((item) => {
          item.classList.toggle("is-selected", item === card);
        });

        this.variantInput.value = card.dataset.variantId;
        this.updateQuantityVariant(card.dataset.variantId);
        this.updateButton(this.form, available);
        this.updatePurchaseOptions(isSet);
        this.updatePrice(card, isSet);
        this.updateDynamicCheckout(isSet);
        this.updatePickupAvailability(isSet);
        this.updateStickyBar(card, isSet, available);
      }

      updateQuantityVariant(variantId) {
        const quantityInput = this.productInfo?.querySelector(
          "[data-quantity-variant-id]"
        );
        if (quantityInput) {
          quantityInput.dataset.quantityVariantId = variantId;
        }
      }

      updateButton(form, available) {
        const button = form?.querySelector('[name="add"]');
        const text = button?.querySelector("span");
        if (!button) return;

        button.disabled = !available;
        button.toggleAttribute("aria-disabled", !available);
        if (text) {
          text.textContent = available
            ? this.dataset.addToCartText
            : this.dataset.soldOutText;
        }
      }

      updatePurchaseOptions(isSet) {
        if (!this.purchaseOptions) return;

        if (isSet) {
          const oneTime = this.purchaseOptions.querySelector(
            'input[value="one-time"]'
          );
          if (oneTime) oneTime.checked = true;
          this.purchaseOptions.syncSelection?.();
        }

        this.purchaseOptions.hidden = isSet;
      }

      updatePrice(card, isSet) {
        if (!this.priceContainer) return;

        if (!isSet) {
          this.priceContainer.innerHTML = this.priceSnapshot;
          return;
        }

        const price = this.priceContainer.querySelector(".f-price");
        const regularPrice = this.priceContainer.querySelector(
          ".f-price__regular .f-price-item--regular"
        );
        const salePrice = this.priceContainer.querySelector(
          ".f-price-item--sale"
        );
        const comparePrice = this.priceContainer.querySelector(
          ".f-price__sale .f-price-item--regular"
        );
        const dailyPrice = this.priceContainer.querySelector(
          ".f-price__per-day"
        );
        const unitPrice = this.priceContainer.querySelector(
          ".f-price__unit-wrapper"
        );
        const onSale =
          Number(card.dataset.comparePrice) > Number(card.dataset.price);

        price?.classList.toggle("f-price--on-sale", onSale);
        price?.classList.toggle(
          "f-price--sold-out",
          card.dataset.available !== "true"
        );
        if (regularPrice) regularPrice.textContent = card.dataset.priceMoney;
        if (salePrice) salePrice.textContent = card.dataset.priceMoney;
        if (comparePrice) {
          comparePrice.textContent = card.dataset.comparePriceMoney;
        }
        if (dailyPrice) dailyPrice.textContent = card.dataset.dailyPriceLabel;
        if (unitPrice) unitPrice.hidden = true;
      }

      updateDynamicCheckout(isSet) {
        if (!this.dynamicCheckout) return;
        this.dynamicCheckout.hidden = isSet
          ? true
          : this.dynamicCheckoutWasHidden;
      }

      updatePickupAvailability(isSet) {
        if (!this.pickupAvailability) return;
        this.pickupAvailability.hidden = isSet
          ? true
          : this.pickupWasHidden;
      }

      updateStickyBar(card, isSet, available) {
        if (!this.stickyBar || !this.stickySelect) return;

        if (!isSet) {
          this.stickySelect.innerHTML = this.stickyOptionsSnapshot;
          this.stickySelect.value = this.originalVariantId;
          if (this.stickyPrice) {
            this.stickyPrice.innerHTML = this.stickyPriceSnapshot;
            this.stickyPrice.className = this.stickyPriceClassSnapshot;
          }
        } else {
          this.stickySelect.innerHTML = "";
          this.stickySelect.add(
            new Option(card.dataset.productTitle, card.dataset.variantId, true, true)
          );
          this.updateStickyPrice(card);
        }

        const stickyForm = this.stickySelect.closest("form");
        this.updateButton(stickyForm, available);
        const stickyQuantity = stickyForm?.querySelector(
          "[data-quantity-variant-id]"
        );
        if (stickyQuantity) {
          stickyQuantity.dataset.quantityVariantId = card.dataset.variantId;
        }
      }

      updateStickyPrice(card) {
        if (!this.stickyPrice) return;

        const salePrice = this.stickyPrice.querySelector(
          ".f-price-item--sale"
        );
        const regularPrices = this.stickyPrice.querySelectorAll(
          ".f-price-item--regular"
        );
        const onSale =
          Number(card.dataset.comparePrice) > Number(card.dataset.price);

        this.stickyPrice.classList.toggle("f-price--on-sale", onSale);
        this.stickyPrice.classList.toggle(
          "f-price--sold-out",
          card.dataset.available !== "true"
        );
        if (salePrice) salePrice.textContent = card.dataset.priceMoney;
        regularPrices.forEach((item) => {
          item.textContent = onSale
            ? card.dataset.comparePriceMoney
            : card.dataset.priceMoney;
        });
      }
    }
  );
}
